import PrimaryButton from "Components/atoms/buttons/primary-button"
import DateInput from "Components/molecule/inputs/date-input"
import SearchSelect from "Components/molecule/inputs/search-select"
import SearchFormContainer from "Components/atoms/containers/search-form-container"
import { IClientEngagementQueryParams } from "models/client-engagement"
import { SelectOption } from "Components/molecule/inputs/select-input"
import { useMemo } from "react"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import useEnterSearch from "hooks/useEnterSearch"

interface SearchClientEngagementProps {
    handleChangeQuery: (key: keyof IClientEngagementQueryParams, value: any) => any,
    handleClearSearch: () => any,
    handleSearch: () => any,
    clients: SelectOption[],
    createdBy: SelectOption[],
    opportunities: SelectOption[],
    query: IClientEngagementQueryParams
    isSearching: boolean
    hide?: {
        client?: boolean
    }
}


const SearchClientEngagement = ({
    handleChangeQuery,
    handleClearSearch,
    handleSearch,
    clients,
    createdBy,
    opportunities,
    query,
    isSearching,
    hide
}: SearchClientEngagementProps) => {

    const { selectProps } = useEnterSearch(handleSearch)

    const clientValue = useMemo(() => {
        const val = query['clientIds'];

        if (val?.length && val.length > 0)
            return val[0]

        return ''
    }, [query])

    const createdByValue = useMemo(() => {
        const val = query['createdByIds'];

        if (val?.length && val.length > 0)
            return val[0]

        return ''
    }, [query])
    const opportunityValue = useMemo(() => {
        const val = query['opportunityIds'];

        if (val?.length && val.length > 0)
            return val[0]

        return ''
    }, [query])

    return (
        <SearchFormContainer
            inputs={
                <>
                    {!hide?.client && (
                        <SearchSelect
                            label="Client"
                            options={clients}
                            value={clientValue}
                            onChange={(e) => handleChangeQuery('clientIds', e?.value ? [e.value] : undefined)}
                            {...selectProps}
                        />
                    )}
                    <SearchSelect
                        label="Created By"
                        options={createdBy}
                        value={createdByValue}
                        onChange={(e) => handleChangeQuery('createdByIds', e?.value ? [e.value] : undefined)}
                        {...selectProps}
                    />
                    <SearchSelect
                        label="Opportunity"
                        options={opportunities}
                        value={opportunityValue}
                        onChange={(e) => handleChangeQuery('opportunityIds', e?.value ? [e.value] : undefined)}
                        {...selectProps}
                    />
                </>
            }
            clearSearchButton={
                <>
                    <PrimaryButton
                        style={{
                            minWidth: '150px'
                        }}
                        disabled={isSearching}
                        onClick={handleSearch}
                    >
                        {isSearching ? 'Searching...' : 'Search'}
                    </PrimaryButton>
                    <SecondaryButton
                        style={{
                            minWidth: '100px'
                        }}
                        disabled={isSearching}
                        onClick={handleClearSearch}
                    >
                        Clear Search
                    </SecondaryButton>
                </>
            }
        />
    )
}

export default SearchClientEngagement